import * as wjcCore from '@grapecity/wijmo';
import * as wjMultirow from '@grapecity/wijmo.grid.multirow';
import * as wjGridFilter from '@grapecity/wijmo.grid.filter';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjInput from '@grapecity/wijmo.input';
import * as wjNav from '@grapecity/wijmo.nav';
import * as uuid from 'uuid';

declare var Stimulsoft: any;
'use strict';

import {HostListener, ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {ToasterService} from 'angular2-toaster';
import {saveAs} from 'file-saver';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {KaitoriyaConfig} from '../config/kaitoriya.config';
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from '@cosbeni/database';
import {ConfirmComponent} from '../ui/modal';
import {GapiSession} from '../gapi/gapi.session';
import {WhiteboardComponent} from '../ui/whiteboard/whiteboard.component';
import {SetUuidAction} from '../ngrx/actions/order.action';
import {StimulsoftFontService} from "../services/stimulsoft-font.service";
import {buildRemoveOrderSql} from "./order-sql";
import {invalidQuantityRows, isValidQuantity, recalcLineAmounts} from "./order-calc";

@Component({
    selector: 'cj-user-bb',
    templateUrl: 'bb.component.html',
})

export class BbComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('orderGrid') orderGrid: wjMultirow.MultiRow;
    @ViewChild('orderLineGrid') orderLineGrid: wjMultirow.MultiRow;
    @ViewChild('customerAutoComplete') customerAutoComplete: wjInput.AutoComplete;
    @ViewChild('findProduct') findProduct: wjInput.AutoComplete;
    @ViewChild('removeOrderPopup') removeOrderPopup: ConfirmComponent;
    @ViewChild('removeSignPopup') removeSignPopup: ConfirmComponent;
    @ViewChild('startDateInput') startDateInput: wjInput.InputDateTime;
    @ViewChild('endDateInput') endDateInput: wjInput.InputDateTime;
    @ViewChild('birthDayInput') birthDayInput: wjInput.InputDate;
    @ViewChild('orderTabPanel') orderTabPanel: wjNav.TabPanel;
    @ViewChild('signModal') signModal: ModalDirective;
    @ViewChild('whiteboard') whiteboard: WhiteboardComponent;
    filter: wjGridFilter.FlexGridFilter;
    fromDate: any;
    toDate: any;
    keyProperty: string = 'お名前(全角カタカナ)';
    keyword: string = '';
    message: string = '';
    orderDefinition: any;
    orderLineDefinition: any;
    screenWidth: number;
    customers: any[] = [];
    products: any[] = [];
    payments: any[] = [];
    sections: any[] = [];
    classifications: any[] = [];
    finalClassifications: any[] = [];
    departments: any[] = [];
    staffs: any[] = [];
    orderHead: any = {};
    hasSign: Boolean = false;
    orders: OrientDBCollectionView;
    orderLine: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    reportTemplate: any = {};
    mode: string = 'view';
    viewer: any;
    viewerOptions: any;
    report: any;
    json: any;
    timeMin: Date = new Date(2000, 1, 1, 9, 0, 0);

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private gapiSession: GapiSession, private stimulsoftFontService: StimulsoftFontService) {
        var today = new Date();
        this.orders = new OrientDBCollectionView(dataService, KaitoriyaConfig.DATABASE, 'SELECT FROM AP_Order_head', 'AP_Order_head', '', 0, 100, true, true, false);
        this.orders.url = KaitoriyaConfig.SERVER_URL;
        this.orders.tokenName = KaitoriyaConfig.DATABASE + '_token';
        this.orders.sortDescriptions.push(new wjcCore.SortDescription('orderDate', false));
        this.createNew();
        this.resizeScreen();
        this.route.queryParams.subscribe(params => {
            this.message = params['message'];
        });
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='支払区分' order by sort",
            count: "SELECT FROM AP_Master WHERE category ='支払区分' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.payments = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='仕入区分' order by sort",
            count: "SELECT FROM AP_Master WHERE category ='仕入区分' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.sections = data.results;
            }
        })
        this.dataService.query({
            sql: 'SELECT FROM AP_Master WHERE category =\'買取区分\' order by sort',
            count: 'SELECT FROM AP_Master WHERE category =\'買取区分\' order by sort',
            fetchPlan: '*:1',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.classifications = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM AP_Master WHERE category =\'最終区分\' order by sort',
            count: 'SELECT FROM AP_Master WHERE category =\'最終区分\' order by sort',
            fetchPlan: '*:1',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.finalClassifications = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM AP_Master WHERE category =\'部門\' order by sort',
            count: 'SELECT FROM AP_Master WHERE category =\'部門\' order by sort',
            fetchPlan: '*:1',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.departments = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM AP_Master WHERE category =\'担当者\' order by sort',
            count: 'SELECT FROM AP_Master WHERE category =\'担当者\' order by sort',
            fetchPlan: '*:1',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            this.staffs = [];
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.staffs.push(item.value);
                }
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM AP_Customer',
            fetchPlan: '*:0',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            this.customers = [];
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.customers.push(item);
                }
            }
        });
        this.store.select<any>('kaitoriyaFeature').subscribe((kaitoriya: any) => {
            if (wjcCore.isObject(kaitoriya.order) && !wjcCore.isNullOrWhiteSpace(kaitoriya.order.uuid)) {
                this.dataService.query({
                    sql: 'SELECT FROM AP_Order_HEAD WHERE uuid = \'' + kaitoriya.order.uuid + '\'',
                    count: 'SELECT FROM AP_Order_HEAD WHERE uuid = \'' + kaitoriya.order.uuid + '\'',
                    fetchPlan: '*:1',
                }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                    if (data.results.length == 1) {
                        this.orderHead = data.results[0];
                        this.convertOrderHead(this.orderHead);
                        this.loadOrderLine(this.orderHead['@rid']);
                        this.getSign();
                        this.orderTabPanel.selectedIndex = 1;
                        this.mode = 'edit';
                        this.store.dispatch(new SetUuidAction(''));
                    }
                });
            }
        });
    }

    ngAfterViewInit() {
        // フォント/ローカライズは StimulsoftFontService が 1 回だけ非同期登録する (ira issue #151 と同対応)
        this.stimulsoftFontService.ensureLoaded();
        let cv = <wjcCore.CollectionView>this.orderLineGrid.collectionView;
        cv.collectionChanged.addHandler((sender: any, e: wjcCore.NotifyCollectionChangedEventArgs) => {
            let price: number,
                quantity: number;
            if (e.action === wjcCore.NotifyCollectionChangedAction.Change && !!e.item) {
                price = +e.item.price;
                quantity = +e.item.quantity;
                if (!isNaN(price) && !isNaN(quantity)) {
                    e.item.amount = price * quantity;
                    this.calculateTotal();
                }
            }
        });
        this.filter = new wjGridFilter.FlexGridFilter(this.orderGrid);
        this.orders.currentChanged.addHandler(this.onCurrentChanged, this);
        this.orders.itemsSourceFunction = this.ordersItemsSourceFunction.bind(this);
        this.orders.filterSpecial = "department LIKE \'%海外%\'"
        this.orders.filterOnServer = true;
        this.orderLineGrid.cellEditEnding.addHandler(this.onCellEditEnding, this);
        this.orderLineGrid.cellEditEnded.addHandler(this.onCellEditEnded, this);
        this.viewerOptions = new Stimulsoft.Viewer.StiViewerOptions();
        this.viewerOptions.appearance.scrollbarsMode = false;
        this.viewer = new Stimulsoft.Viewer.StiViewer(this.viewer, 'StiViewer', false);
        this.report = new Stimulsoft.Report.StiReport();
        if (!wjcCore.isNullOrWhiteSpace(this.message)) {
            this.toasterService.pop('info', '情報', this.message);
        }
    }

    /** 明細グリッドのセルが属する列の binding (MultiRow はセル位置から引く)。 */
    private lineBinding(grid: any, args: any): string {
        const col = typeof grid.getBindingColumn === 'function'
            ? grid.getBindingColumn(args.panel, args.row, args.col)
            : grid.columns[args.col];
        return col ? col.binding : '';
    }

    /** 数量は整数のみ。小数・数値以外は確定させず、編集状態のまま知らせる。 */
    onCellEditEnding(grid: any, args: any): void {
        if (args.cancel || this.lineBinding(grid, args) != 'quantity' || !grid.activeEditor) {
            return;
        }
        const text = String(grid.activeEditor.value || '').replace(/,/g, '').trim();
        if (text === '') {
            return;
        }
        if (!isValidQuantity(Number(text))) {
            args.cancel = true;
            args.stayInEditMode = true;
            this.toasterService.pop('warning', '数量', '数量は整数で入力してください。');
        }
    }

    onCellEditEnded(grid: any, args: any): void {
        // 列の判定に依存せず、明細の編集が確定するたびに金額と合計を計算し直す
        this.calculateTotal();
        grid.refresh();
    }

    //@HostListener('window:resize', ['$event'])
    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth >= 768) {
            this.orderLineDefinition =
                [
                    {
                        cells: [
                            {binding: 'productName', header: '商品名', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'manufactureName', header: 'メーカー', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'modelNumber', header: '型番', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'quantity', header: '数量', dataType: 'Number', width: 80},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'unit', header: '単位', width: 40},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'price', header: '単価', dataType: 'Number', width: 80},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'amount', header: '金額', dataType: 'Number', width: 80, isReadOnly: true},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'memo', header: '備考', width: 320},
                        ]
                    },
                ];
            this.orderDefinition =
                [
                    {
                        cells: [
                            {binding: 'id', header: '番号', dataType: 'Number', width: 80}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'branch', header: '枝番', dataType: 'Number', width: 80}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'status', header: '区分', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'finalStatus', header: '最終区分', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'department', header: '部門', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'name', header: 'お名前', width: 160},
                        ]
                    },
                    {
                        cells: [
                            {binding: 'orderDate', header: '受付日', dataType: 'Date', format: 'yyyy/MM/dd', width: 100}
                        ]
                    },
                    {
                        cells: [
                            {
                                binding: 'startDate',
                                header: '買取日',
                                dataType: 'Date',
                                format: 'yyyy/MM/dd HH:mm',
                                width: 120
                            }
                        ]
                    },
                    {
                        cells: [
                            {binding: 'address', header: '住所', width: 200}
                        ]
                    },
                    {
                        cells: [
                            {binding: 'total', header: '合計金額', dataType: 'Number', width: 80}
                        ]
                    },
                ];
        } else {
            this.orderLineDefinition =
                [
                    {
                        colspan: 3,
                        cells: [
                            {binding: 'productName', header: '商品名', width: 100, colspan: 2},
                            {binding: 'unit', header: '単位', width: 100},
                            {binding: 'manufactureName', header: 'メーカー', colspan: 2},
                            {binding: 'quantity', header: '数量', dataType: 'Number'},
                            {binding: 'modelNumber', header: '型番', colspan: 2},
                            {binding: 'price', header: '単価', dataType: 'Number'},
                            {binding: 'memo', header: '備考', colspan: 2},
                            {binding: 'amount', header: '金額', dataType: 'Number', isReadOnly: true},
                        ]
                    }
                ];
            this.orderDefinition =
                [
                    {
                        cells: [
                            {binding: 'id', header: '番号', width: 60, rowspan: 2},
                            {binding: 'branch', header: '枝番', dataType: 'Number', width: 60}
                        ]
                    },
                    {
                        colspan: 3,
                        cells: [
                            {binding: 'status', header: '区分', width: 80},
                            {binding: 'finalStatus', header: '最終区分', width: 80},
                            {binding: 'name', header: 'お名前', width: 120},
                            {binding: 'orderDate', header: '受付日', dataType: 'Date', format: 'MM/dd', width: 80},
                            {
                                binding: 'startDate',
                                header: '買取日',
                                dataType: 'Date',
                                format: 'MM/dd HH:mm',
                                width: 80
                            },
                            {binding: 'total', header: '合計金額', dataType: 'Number', width: 120},
                            {binding: 'address', header: '住所', colspan: 3}
                        ]
                    }
                ];
        }
    }

    search(): void {
        let where = ['department LIKE \'%海外%\''];
        if (!wjcCore.isNullOrWhiteSpace(this.keyword)) {
            let filter = [];
            if (this.keyProperty == 'お名前(全角カタカナ)' || this.keyProperty == '複数項目') {
                filter.push('name LIKE \'%' + this.keyword + '%\'');
            }
            if (this.keyProperty == '買取区分' || this.keyProperty == '複数項目') {
                filter.push('status LIKE \'%' + this.keyword + '%\'');
            }
            if (this.keyProperty == '住所' || this.keyProperty == '複数項目') {
                filter.push('state LIKE \'%' + this.keyword + '%\'');
                filter.push('city LIKE \'%' + this.keyword + '%\'');
                filter.push('street LIKE \'%' + this.keyword + '%\'');
                filter.push('building LIKE \'%' + this.keyword + '%\'');
            }
            if (this.keyProperty == '電話番号' || this.keyProperty == '複数項目') {
                filter.push('telephone LIKE \'%' + this.keyword + '%\'');
            }
            where.push('(' + filter.join(' OR ') + ')');
        }
        if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
            let filter = [];
            filter.push('(orderDate >= \'' + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + '\' AND orderDate < \'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + '\')');
            filter.push('(startDate >= \'' + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + '\' AND startDate < \'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + '\')');
            filter.push('(endDate >= \'' + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + '\' AND endDate < \'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + '\')');
            where.push('(' + filter.join(' OR ') + ')');
        } else {
            if (wjcCore.isDate(this.fromDate)) {
                let filter = [];
                filter.push('orderDate >= \'' + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + '\'');
                filter.push('startDate >= \'' + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + '\'');
                filter.push('endDate >= \'' + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + '\'');
                where.push('(' + filter.join(' OR ') + ')');
            }
            if (wjcCore.isDate(this.toDate)) {
                let filter = [];
                filter.push('orderDate < \'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + '\'');
                filter.push('startDate < \'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + '\'');
                filter.push('endDate < \'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + '\'');
                where.push('(' + filter.join(' OR ') + ')');
            }
        }
        this.orders.filterOnServer = false;
        this.orders.filterSpecial = where.join(' AND ');
        this.orders.filterOnServer = true;
    }

    createNew(): void {
        var today = new Date();
        var orderDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.orderHead = {
            '@class': 'AP_Order_Head',
            '@rid': '#-1:-1',
            branch: 1,
            customer: null,
            name: '',
            nameKanji: '',
            postalCode: '',
            state: '',
            city: '',
            street: '',
            building: '',
            telephone: '',
            mobile: '',
            staff: '',
            orderDate: orderDate,
            startDate: null,
            endDate: null,
            birthDay: null,
            japanDate: false,
            amount: 0,
            tax: 0,
            total: 0,
            status: '買取',
            finalStatus: '完了',
            identityType: '免許書',
            identityNumber: '',
            uuid: uuid.v4().split('-').join(''),
            memo: '',
            abroad: false,
            department: '海外',
            payment: "現金",
            section: "一般",
        };
        this.orderLine.sourceCollection = wjcCore.asArray([]);
        this.orderLine.refresh();
    }

    copyNew(): void {
        let orderHead = {...this.orderHead};
        delete orderHead['@version'];
        delete orderHead['@type'];
        orderHead['@rid'] = '#-1:-1';
        orderHead.branch = orderHead.branch + 1;
        orderHead.uuid = uuid.v4().split('-').join('');
        this.orderHead = orderHead;
    }

    ordersItemsSourceFunction(items: any[]) {
        for (let item of items) {
            this.convertOrderHead(item);
        }
        return items;
    }

    convertOrderHead(item: any): void {
        if (isOrientDate(item.orderDate)) {
            item.orderDate = asOrientDate(item.orderDate);
        }
        if (isOrientDate(item.startDate)) {
            item.startDate = asOrientDate(item.startDate);
        }
        if (isOrientDate(item.endDate)) {
            item.endDate = asOrientDate(item.endDate);
        }
        if (isOrientDate(item.birthDay)) {
            item.birthDay = asOrientDate(item.birthDay);
        }
        let address = '';
        if (!wjcCore.isNullOrWhiteSpace(item.state)) {
            address = address + item.state;
        }
        if (!wjcCore.isNullOrWhiteSpace(item.city)) {
            address = address + item.city;
        }
        if (!wjcCore.isNullOrWhiteSpace(item.street)) {
            address = address + item.street;
        }
        if (!wjcCore.isNullOrWhiteSpace(item.building)) {
            address = address + item.building;
        }
        item.address = address;
    }

    loadOrderLine(rid: string): void {
        this.dataService.query({
            sql: 'SELECT FROM AP_Order_Line WHERE header = ' + rid + ' ORDER BY sort',
            count: 'SELECT FROM AP_Order_Line WHERE header = ' + rid + ' ORDER BY sort',
            fetchPlan: '*:1',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            this.orderLine.sourceCollection = wjcCore.asArray(data.results);
            this.orderLine.refresh();
        });
    }

    calculateTotal(): void {
        // 金額は入力不可の計算項目。数量・単価がどの操作で変わっても保存値がずれないよう、
        // 合計計算のたびに全明細を 単価×数量 で計算し直す (order-calc.ts)。
        this.orderHead.total = recalcLineAmounts(this.orderLine.items);
        this.orderHead.tax = Math.floor(this.orderHead.total * 10 / 110);
        this.orderHead.amount = this.orderHead.total - this.orderHead.tax;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (!!this.orders.currentItem && this.mode == 'view') {
            this.orderHead = this.orders.currentItem;
            if (wjcCore.isObject(this.orderHead.customer)) {
                this.customerAutoComplete.itemsSource = new wjcCore.CollectionView([this.orderHead.customer]);
            }
            this.loadOrderLine(this.orderHead['@rid']);
            this.getSign();
        }
    }

    onChangeStartDate(): void {
        if (this.orderHead.endDate < this.orderHead.startDate) {
            this.endDateInput.min = this.orderHead.startDate;
            this.endDateInput.value = this.orderHead.startDate;
        }
        if (this.orderHead.endDate == null) {
            this.endDateInput.min = this.orderHead.startDate;
            this.endDateInput.value = this.orderHead.startDate;
        }
    }

    onChangeJapanDate(): void {
        if (this.orderHead.japanDate) {
            this.birthDayInput.format = 'gggyy年MM月dd日';
            this.birthDayInput.calendar.formatYearMonth = 'gggyy年MM月';
            this.birthDayInput.calendar.formatYear = 'gggyy年';
        } else {
            this.birthDayInput.format = 'yyyy/MM/dd';
            this.birthDayInput.calendar.formatYearMonth = 'y';
            this.birthDayInput.calendar.formatYear = 'yyyy';
        }
    }

    getCustomerFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(this.customers);
            return;
        } else {
            callback(this.customers.filter(customer => {
                let match = false;
                if (customer.hasOwnProperty('id') && customer.id.indexOf(query) >= 0) {
                    match = true;
                }
                if (customer.hasOwnProperty('name') && customer.name.indexOf(query) >= 0) {
                    match = true;
                }
                if (customer.hasOwnProperty('nameKanji') && customer.nameKanji.indexOf(query) >= 0) {
                    match = true;
                }
                if (customer.hasOwnProperty('telephone') && customer.telephone.indexOf(query) >= 0) {
                    match = true;
                }
                return match;
            }));
        }
    }

    getCustomer = this.getCustomerFunction.bind(this);

    getProductFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push('category LIKE \'%' + query + '%\'');
        where.push('name LIKE \'%' + query + '%\'');
        where.push('model LIKE \'%' + query + '%\'');
        where.push('manufacture LIKE \'%' + query + '%\'');
        this.dataService.query({
            sql: 'SELECT FROM AP_Product WHERE ' + where.join(' OR '),
            count: 'SELECT FROM AP_Product WHERE ' + where.join(' OR ')
        }, KaitoriyaConfig.SERVER_URL).subscribe(response => {
            this.products = [];
            for (let item of wjcCore.asArray(response.results)) {
                let display = '';
                if (item.hasOwnProperty('name') && !wjcCore.isNullOrWhiteSpace(item.name)) {
                    display = item.name;
                }
                if (item.hasOwnProperty('manufacture') && !wjcCore.isNullOrWhiteSpace(item.manufacture)) {
                    display = display + ' ' + item.manufacture;
                }
                if (item.hasOwnProperty('model') && !wjcCore.isNullOrWhiteSpace(item.model)) {
                    display = display + ' ' + item.model;
                }
                if (item.hasOwnProperty('price') && wjcCore.isNumber(item.price)) {
                    display = display + ' ' + item.price;
                }
                item.display = display;
                this.products.push(item);
            }
            callback(this.products);
        });
    }

    getProduct = this.getProductFunction.bind(this);

    hasProduct(): boolean {
        let result = false;
        if (wjcCore.isObject(this.findProduct) && wjcCore.isObject(this.findProduct.selectedItem)) {
            result = true;
        }
        return result;
    }

    addCarryOutFee() {
        let item = {
            productName: '搬出手数料',
            manufactureName: '',
            modelNumber: '',
            quantity: 1,
            unit: '',
            price: 0,
            amount: 0,
            oversea: '',
            memo: ''
        };
        item.amount = item.quantity * item.price;
        this.orderLine.sourceCollection.push(item);
        this.orderLine.refresh();
        this.calculateTotal();
    }

    addProduct() {
        let item = {
            productName: '',
            manufactureName: '',
            modelNumber: '',
            quantity: 1,
            unit: '',
            price: 0,
            amount: 0,
            oversea: '',
            memo: '',
        };
        if (this.findProduct.selectedItem.hasOwnProperty('name') && !wjcCore.isNullOrWhiteSpace(this.findProduct.selectedItem.name)) {
            item.productName = this.findProduct.selectedItem.name;
        }
        if (this.findProduct.selectedItem.hasOwnProperty('manufacture') && !wjcCore.isNullOrWhiteSpace(this.findProduct.selectedItem.manufacture)) {
            item.manufactureName = this.findProduct.selectedItem.manufacture;
        }
        if (this.findProduct.selectedItem.hasOwnProperty('model') && !wjcCore.isNullOrWhiteSpace(this.findProduct.selectedItem.model)) {
            item.modelNumber = this.findProduct.selectedItem.model;
        }
        if (this.findProduct.selectedItem.hasOwnProperty('unit') && !wjcCore.isNullOrWhiteSpace(this.findProduct.selectedItem.unit)) {
            item.unit = this.findProduct.selectedItem.unit;
        }
        if (this.findProduct.selectedItem.hasOwnProperty('price') && wjcCore.isNumber(this.findProduct.selectedItem.price)) {
            item.price = this.findProduct.selectedItem.price;
        }
        if (this.findProduct.selectedItem.hasOwnProperty('memo') && !wjcCore.isNullOrWhiteSpace(this.findProduct.selectedItem.memo)) {
            item.memo = this.findProduct.selectedItem.memo;
        }
        item.amount = item.quantity * item.price;
        this.orderLine.sourceCollection.push(item);
        this.orderLine.refresh();
        this.calculateTotal();
    }

    setCustomer() {
        if (wjcCore.isObject(this.orderHead.customer)) {
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.name)) {
                this.orderHead.name = this.orderHead.customer.name;
            } else {
                this.orderHead.name = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.nameKanji)) {
                this.orderHead.nameKanji = this.orderHead.customer.nameKanji;
            } else {
                this.orderHead.nameKanji = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.postalCode)) {
                this.orderHead.postalCode = this.orderHead.customer.postalCode;
            } else {
                this.orderHead.postalCode = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.state)) {
                this.orderHead.state = this.orderHead.customer.state;
            } else {
                this.orderHead.state = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.city)) {
                this.orderHead.city = this.orderHead.customer.city;
            } else {
                this.orderHead.city = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.street)) {
                this.orderHead.street = this.orderHead.customer.street;
            } else {
                this.orderHead.street = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.building)) {
                this.orderHead.building = this.orderHead.customer.building;
            } else {
                this.orderHead.building = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.telephone)) {
                this.orderHead.telephone = this.orderHead.customer.telephone;
            } else {
                this.orderHead.telephone = '';
            }
            if (!wjcCore.isNullOrWhiteSpace(this.orderHead.customer.mobile)) {
                this.orderHead.mobile = this.orderHead.customer.mobile;
            } else {
                this.orderHead.mobile = '';
            }
        }
    }

    deleteOrderLine(): void {
        if (!!this.orderLine.currentItem) {
            var index = this.orderLine.sourceCollection.indexOf(this.orderLine.currentItem);
            this.orderLine.sourceCollection.splice(index, 1);
            this.orderLine.refresh();
        }
    }

    saveOrder(): void {
        const badRows = invalidQuantityRows(this.orderLine.items);
        if (badRows.length > 0) {
            this.toasterService.pop('error', '保存', '数量は整数で入力してください (明細 ' + badRows.join(', ') + ' 行目)。');
            return;
        }
        this.calculateTotal();
        this.orderLine.refresh();
        let orderHead = {...this.orderHead};
        if (wjcCore.isDate(orderHead.orderDate)) {
            orderHead.orderDate = wjcCore.Globalize.formatDate(orderHead.orderDate, 'yyyy-MM-dd');
        }
        if (wjcCore.isDate(orderHead.startDate)) {
            orderHead.startDate = wjcCore.Globalize.formatDate(orderHead.startDate, 'yyyy-MM-dd HH:mm:ss');
        }
        if (wjcCore.isDate(orderHead.endDate)) {
            orderHead.endDate = wjcCore.Globalize.formatDate(orderHead.endDate, 'yyyy-MM-dd HH:mm:ss');
        }
        if (wjcCore.isDate(orderHead.birthDay)) {
            orderHead.birthDay = wjcCore.Globalize.formatDate(orderHead.birthDay, 'yyyy-MM-dd');
        }
        if (wjcCore.isDate(orderHead.paymentDate)) {
            orderHead.paymentDate = wjcCore.Globalize.formatDate(orderHead.paymentDate, 'yyyy-MM-dd');
        }
        if (wjcCore.isNullOrWhiteSpace(orderHead.identityType)) {
            orderHead.identityType = '';
        }
        let sql = 'BEGIN\n';
        let mapHead = [];
        Object.entries(orderHead).forEach(([key, value]) => {
            if (wjcCore.isNumber(value) && !key.startsWith('@')) {
                mapHead.push(key + '=' + value);
            } else {
                if (key == "customer") {
                    if (wjcCore.isObject(value)) {
                        mapHead.push("customer=" + value['@rid'])
                    }
                } else if (key != 'address' && !key.startsWith('@') && value != null) {
                    if (wjcCore.isString(value)) {
                        let v: string = value;
                        v = v.replace(/\\/g, '\\\\');
                        v = v.replace(/\n/g, '\\n');
                        v = v.replace(/\t/g, '\\t');
                        v = v.replace(/'/g, '\\\'');
                        v = v.replace(/"/g, '\\"');
                        value = v;
                    }
                    mapHead.push(key + '=\'' + value + '\'');
                }
            }
        });
        if (orderHead['@rid'] == '#-1:-1') {
            sql = sql + 'let header = INSERT INTO AP_Order_Head SET id = sequence(\'header\').next(), ' + mapHead.join(',') + ' return $current\n';
        } else {
            sql = sql + 'UPDATE AP_Order_Head SET ' + mapHead.join(',') + ' WHERE @rid = ' + this.orderHead['@rid'] + '\n';
            sql = sql + 'DELETE VERTEX AP_Order_Line WHERE header = ' + this.orderHead['@rid'] + '\n';
        }
        let sort = 1;
        for (let item of this.orderLine.items) {
            let mapLine = [];
            Object.entries(item).forEach(([key, value]) => {
                if (wjcCore.isNumber(value) && !key.startsWith('@')) {
                    mapLine.push(key + '=' + value);
                } else {
                    if (key != 'header' && key != 'address' && !key.startsWith('@') && value != null) {
                        mapLine.push(key + '=\'' + value + '\'');
                    }
                }
            });
            if (orderHead['@rid'] == '#-1:-1') {
                mapLine.push('header = $header');
            } else {
                mapLine.push('header = ' + orderHead['@rid'] + '');
            }
            mapLine.push('sort = ' + sort);
            sort = sort + 1;
            sql = sql + 'INSERT INTO AP_Order_Line SET ' + mapLine.join(',') + '\n';
        }
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
            this.toasterService.pop('info', '保存', '保存されました。');
            if (this.canSyncEvent()) {
                this.syncEvent();
            }
            if (this.orderHead.abroad && this.orderHead.sync && this.gapiSession.isSignedIn()) {
                gapi.client['calendar'].events.delete({
                    calendarId: 'primary',
                    eventId: this.orderHead.uuid
                }).then((response) => {
                    this.toasterService.pop('info', 'カレンダー更新', 'カレンダー更新されました。');
                });
            }
            this.dataService.query({
                sql: 'SELECT FROM AP_Order_HEAD WHERE uuid = \'' + this.orderHead.uuid + '\'',
                count: 'SELECT FROM AP_Order_HEAD WHERE uuid = \'' + this.orderHead.uuid + '\'',
                fetchPlan: '*:1',
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                if (data.results.length == 1) {
                    this.orderHead = data.results[0];
                    this.convertOrderHead(this.orderHead);
                    this.loadOrderLine(this.orderHead['@rid']);
                    this.getSign();
                    this.mode = 'view';
                }
            });
        }, (error: any) => {
            this.toasterService.pop('error', '保存', '失敗しました。');
        });
    }

    confirmRemoveOrder(): void {
        this.removeOrderPopup.modal.show();
    }

    confirmRemoveSign(): void {
        this.removeSignPopup.modal.show();
    }

    removeOrder(): void {
        // 明細・署名画像・ヘッダーを 1 トランザクションでまとめて削除する (孤児明細を残さない)。
        // 詳細は order-sql.ts の buildRemoveOrderSql を参照。
        this.dataService.batch({sql: buildRemoveOrderSql(this.orderHead['@rid'], this.orderHead.uuid)}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', '削除', '削除されました。');
                if (this.canSyncEvent()) {
                    if (this.orderHead.sync) {
                        gapi.client['calendar'].events.delete({
                            calendarId: 'primary',
                            eventId: this.orderHead.uuid
                        }).then((response) => {
                            this.toasterService.pop('info', 'カレンダー更新', 'カレンダー更新されました。');
                        });
                    }
                }
                this.mode = 'view';
                this.orders.queryData();
                this.toTopOrder();
            },
            (error) => {
                this.toasterService.pop('error', '削除', '失敗しました。');
            });
    }

    removeSign(): void {
        let command = 'DELETE VERTEX AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'';
        this.dataService.command({sql: command}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', '削除', '削除されました。');
                this.getSign();
            },
            (error) => {
                this.toasterService.pop('error', '削除', '失敗しました。');
            });
    }

    toTopOrder(): void {
        this.orders.moveCurrentToFirst();
        if (!!this.orders.currentItem && this.mode == 'view') {
            this.orderHead = this.orders.currentItem;
            this.loadOrderLine(this.orderHead['@rid']);
            this.getSign();
        }
    }

    generatePDF(name) {
        if (this.mode == 'view' && this.orderHead != null) {
            if (this.reportTemplate.hasOwnProperty('name') && this.reportTemplate.name == name) {
                this.exportPDF(name);
            } else {
                this.dataService.query({
                    sql: 'SELECT FROM AP_Report WHERE name =\'' + name + '\'',
                    count: 'SELECT FROM AP_Report WHERE name =\'' + name + '\'',
                    fetchPlan: '*:1',
                }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results) && data.results.length == 1) {
                        this.reportTemplate = data.results[0];
                        this.exportPDF(name);
                    }
                });
            }
        }
    }

    async exportPDF(name) {
        await this.stimulsoftFontService.ensureLoaded();
        let r = (JSON.parse(JSON.stringify(this.reportTemplate.content)));
        delete r['@type'];
        delete r['@version'];
        this.report = new Stimulsoft.Report.StiReport();
        if (name.indexOf('58mm') >= 0) {
            r.Pages[0].PageHeight = r.Pages[0].PageHeight - 1.6 + this.orderLine.items.length * 0.8;
            r.Pages[1].PageHeight = r.Pages[1].PageHeight - 1.6 + this.orderLine.items.length * 0.8;
        }
        this.report.load(r);
        this.report.dictionary.databases.clear();
        let order: any = {orderHead: {}, orderLines: []};
        order.orderHead = this.orderHead;
        if (this.orderLine.items.length > 0) {
            order.orderLines = this.orderLine.items;
        }
        if (name.indexOf('買取明細書') >= 0) {
            this.dataService.query({
                sql: 'SELECT FROM AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'',
                count: 'SELECT FROM AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'',
                fetchPlan: '*:1',
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results) && data.results.length == 1) {
                    order.orderHead.sign = data.results[0].image;
                }
                this.json = order;
                let dataSet = new Stimulsoft.System.Data.DataSet('kaitoriya');
                dataSet.readJson(order);
                this.report.regData(dataSet.dataSetName, 'kaitoriya', dataSet);
                var pdfSettings = new Stimulsoft.Report.Export.StiPdfExportSettings();
                pdfSettings.embeddedFonts = true;
                var pdfService = new Stimulsoft.Report.Export.StiPdfExportService();
                var stream = new Stimulsoft.System.IO.MemoryStream();
                var report = this.report;
                report.renderAsync(function () {
                    pdfService.exportToAsync(function () {
                        var data = stream.toArray();
                        var blob = new Blob([new Uint8Array(data)], {type: 'application/pdf'});
                        saveAs(blob, name + order.orderHead.id + '.pdf');
                    }, report, stream, pdfSettings);
                }, false);
            });
        } else {
            this.json = order;
            let dataSet = new Stimulsoft.System.Data.DataSet('kaitoriya');
            dataSet.readJson(order);
            this.report.regData(dataSet.dataSetName, 'kaitoriya', dataSet);
            var pdfSettings = new Stimulsoft.Report.Export.StiPdfExportSettings();
            pdfSettings.embeddedFonts = true;
            var pdfService = new Stimulsoft.Report.Export.StiPdfExportService();
            var stream = new Stimulsoft.System.IO.MemoryStream();
            var report = this.report;
            report.renderAsync(function () {
                pdfService.exportToAsync(function () {
                    var data = stream.toArray();
                    var blob = new Blob([new Uint8Array(data)], {type: 'application/pdf'});
                    saveAs(blob, name + order.orderHead.id + '.pdf');
                }, report, stream, pdfSettings);
            }, false);
        }
    }

    printPDF(name) {
        if (this.mode == 'view' && this.orderHead != null) {
            if (this.reportTemplate.hasOwnProperty('name') && this.reportTemplate.name == name) {
                this.siiPrint(name);
            } else {
                this.dataService.query({
                    sql: 'SELECT FROM AP_Report WHERE name =\'' + name + '\'',
                    count: 'SELECT FROM AP_Report WHERE name =\'' + name + '\'',
                    fetchPlan: '*:1',
                }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results) && data.results.length == 1) {
                        this.reportTemplate = data.results[0];
                        this.siiPrint(name);
                    }
                });
            }
        }
    }

    siiPrint(name) {
        let r = (JSON.parse(JSON.stringify(this.reportTemplate.content)));
        delete r['@type'];
        delete r['@version'];
        this.report = new Stimulsoft.Report.StiReport();
        r.Pages[0].PageHeight = r.Pages[0].PageHeight - 1.6 + this.orderLine.items.length * 0.8;
        r.Pages[1].PageHeight = r.Pages[1].PageHeight - 1.6 + this.orderLine.items.length * 0.8;
        this.report.load(r);
        this.report.dictionary.databases.clear();
        let order: any = {orderHead: {}, orderLines: []};
        order.orderHead = this.orderHead;
        if (this.orderLine.items.length > 0) {
            order.orderLines = this.orderLine.items;
        }
        if (name.indexOf('買取明細書') >= 0) {
            this.dataService.query({
                sql: 'SELECT FROM AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'',
                count: 'SELECT FROM AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'',
                fetchPlan: '*:1',
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results) && data.results.length == 1) {
                    order.orderHead.sign = data.results[0].image;
                }
                this.json = order;
                let dataSet = new Stimulsoft.System.Data.DataSet('kaitoriya');
                dataSet.readJson(order);
                this.report.regData(dataSet.dataSetName, 'kaitoriya', dataSet);
                let pdfSettings = new Stimulsoft.Report.Export.StiPdfExportSettings();
                pdfSettings.embeddedFonts = true;
                pdfSettings.useUnicode = true;
                let pdfService = new Stimulsoft.Report.Export.StiPdfExportService();
                let stream = new Stimulsoft.System.IO.MemoryStream();
                var report = this.report;
                report.renderAsync(function () {
                    pdfService.exportToAsync(function () {
                        var data = stream.toArray();
                        let pdfData = Stimulsoft.System.Convert.toBase64String(data);
                        let url = 'siiprintagent://1.0/print?'
                            + 'CallbackSuccess=' + encodeURIComponent('https://kaitoriya.info/#/user/order?message=success') + '&'
                            + 'CallbackFail=' + encodeURIComponent('https://kaitoriya.info/#/user/order?message=error') + '&'
                            + 'Format=' + 'pdf' + '&'
                            + 'Data=' + encodeURIComponent(pdfData) + '&'
                            + 'ErrorDialog=' + 'yes' + '&'
                            + 'Timeout=' + '60000' + '&'
                            + 'SelectOnError=' + 'no';
                        location.href = url;
                    }, report, stream, pdfSettings);
                }, false);
            });
        } else {
            this.json = order;
            let dataSet = new Stimulsoft.System.Data.DataSet('kaitoriya');
            dataSet.readJson(order);
            this.report.regData(dataSet.dataSetName, 'kaitoriya', dataSet);
            let pdfSettings = new Stimulsoft.Report.Export.StiPdfExportSettings();
            pdfSettings.embeddedFonts = true;
            pdfSettings.useUnicode = true;
            let pdfService = new Stimulsoft.Report.Export.StiPdfExportService();
            let stream = new Stimulsoft.System.IO.MemoryStream();
            var report = this.report;
            report.renderAsync(function () {
                pdfService.exportToAsync(function () {
                    var data = stream.toArray();
                    let pdfData = Stimulsoft.System.Convert.toBase64String(data);
                    let url = 'siiprintagent://1.0/print?'
                        + 'CallbackSuccess=' + encodeURIComponent('https://kaitoriya.info/#/user/order?message=success') + '&'
                        + 'CallbackFail=' + encodeURIComponent('https://kaitoriya.info/#/user/order?message=error') + '&'
                        + 'Format=' + 'pdf' + '&'
                        + 'Data=' + encodeURIComponent(pdfData) + '&'
                        + 'ErrorDialog=' + 'yes' + '&'
                        + 'Timeout=' + '60000' + '&'
                        + 'SelectOnError=' + 'no';
                    location.href = url;
                }, report, stream, pdfSettings);
            }, false);
        }
    }

    canSyncEvent(): boolean {
        let result = true;
        if (!wjcCore.isDate(this.orderHead.startDate)) {
            result = false;
        }
        if (!wjcCore.isDate(this.orderHead.endDate)) {
            result = false;
        }
        if (this.orderHead.abroad) {
            result = false;
        }
        if (!this.gapiSession.isSignedIn()) {
            result = false;
        }
        return result;
    }

    syncEvent() {
        let summary = '';
        let description = '';
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.status)) {
            summary = summary + this.orderHead.status;
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.city)) {
            summary = summary + ' ' + this.orderHead.city;
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.name)) {
            description = description + this.orderHead.name + '様\n';
        }
        if (wjcCore.isDate(this.orderHead.startDate) && wjcCore.isDate(this.orderHead.endDate)) {
            if (wjcCore.Globalize.formatDate(this.orderHead.startDate, 'yyyy-MM-dd') == wjcCore.Globalize.formatDate(this.orderHead.endDate, 'yyyy-MM-dd')) {
                description = description + wjcCore.Globalize.formatDate(this.orderHead.startDate, 'HH:mm') + '-' + wjcCore.Globalize.formatDate(this.orderHead.endDate, 'HH:mm') + '\n';
            }
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.staff)) {
            description = description + '担当者:' + this.orderHead.staff + '\n';
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.telephone)) {
            description = description + '電話番号:' + this.orderHead.telephone + '\n';
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.mobile)) {
            description = description + '携帯番号:' + this.orderHead.mobile + '\n';
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.memo)) {
            description = description + this.orderHead.memo + '\n\n\n';
        }
        let address = '';
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.state)) {
            address = address + this.orderHead.state;
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.city)) {
            address = address + this.orderHead.city;
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.street)) {
            address = address + this.orderHead.street;
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.building)) {
            address = address + '\n' + this.orderHead.building;
        }
        this.orderHead.address = address;
        let pTotal = 0;
        let nTotal = 0;
        for (let item of this.orderLine.items) {
            if (!wjcCore.isNullOrWhiteSpace(item.productName)) {
                description = description + item.productName;
            }
            if (wjcCore.isNumber(item.price) && wjcCore.isNumber(item.quantity) && wjcCore.isNumber(item.amount)) {
                description = description + ' ＠' + item.price + ' ×' + item.quantity + ' 金額:' + item.amount;
                if (item.amount > 0) {
                    pTotal = pTotal + item.amount;
                } else {
                    nTotal = nTotal + item.amount;
                }
            }
            description = description + '\n';
        }
        if (pTotal > 0 || nTotal < 0) {
            description = description + '買取合計 ' + pTotal + '\n';
            description = description + '搬出費用合計 ' + nTotal + '\n';
        }
        if (!wjcCore.isNullOrWhiteSpace(this.orderHead.total)) {
            description = description + '合計金額:' + this.orderHead.total + '\n';
        }
        let reqBody: any = {
            'id': this.orderHead.uuid,
            'summary': summary,
            'location': this.orderHead.address,
            'description': description,
            'start': {
                'dateTime': this.orderHead.startDate,
                'timeZone': 'Asia/Tokyo'
            },
            'end': {
                'dateTime': this.orderHead.endDate,
                'timeZone': 'Asia/Tokyo'
            }
        };
        for (let classification of this.classifications) {
            if (classification.value == this.orderHead.status && wjcCore.isNumber(classification.colorId)) {
                if (classification.colorId > 0 && classification.colorId < 12) {
                    reqBody.colorId = classification.colorId;
                }
            }
        }
        if (this.orderHead.sync) {
            gapi.client['calendar'].events.update({
                calendarId: 'primary',
                eventId: reqBody.id,
                resource: reqBody
            }).then((response) => {
                this.toasterService.pop('info', 'カレンダー更新', 'カレンダー更新されました。');
            }, (error) => {
                if (error.status == 404) {
                    gapi.client['calendar'].events.insert({
                        calendarId: 'primary',
                        resource: reqBody
                    }).then((response) => {
                        let sql = 'BEGIN\n';
                        sql = sql + 'UPDATE AP_Order_Head SET sync = true WHERE uuid = \'' + this.orderHead.uuid + '\'\n';
                        sql = sql + 'COMMIT RETRY 100\n';
                        this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                            this.orderHead.sync = true;
                        });
                        this.toasterService.pop('info', 'カレンダー追加', 'カレンダー追加されました。');
                    });
                }
            });
        } else {
            gapi.client['calendar'].events.get({
                calendarId: 'primary',
                eventId: reqBody.id,
            }).then((res) => {
                let sql = 'BEGIN\n';
                sql = sql + 'UPDATE AP_Order_Head SET sync = true WHERE uuid = \'' + this.orderHead.uuid + '\'\n';
                sql = sql + 'COMMIT RETRY 100\n';
                this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                    this.orderHead.sync = true;
                });
                gapi.client['calendar'].events.update({
                    calendarId: 'primary',
                    eventId: reqBody.id,
                    resource: reqBody
                }).then((response) => {
                    this.toasterService.pop('info', 'カレンダー更新', 'カレンダー更新されました。');
                }, (error) => {
                    gapi.client['calendar'].events.insert({
                        calendarId: 'primary',
                        resource: reqBody
                    }).then((response) => {
                        let sql = 'BEGIN\n';
                        sql = sql + 'UPDATE AP_Order_Head SET sync = true WHERE uuid = \'' + this.orderHead.uuid + '\'\n';
                        sql = sql + 'COMMIT RETRY 100\n';
                        this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                            this.orderHead.sync = true;
                        });
                        this.toasterService.pop('info', 'カレンダー追加', 'カレンダー追加されました。');
                    });
                });
            }, (error) => {
                if (error.status == 404) {
                    gapi.client['calendar'].events.insert({
                        calendarId: 'primary',
                        resource: reqBody
                    }).then((response) => {
                        let sql = 'BEGIN\n';
                        sql = sql + 'UPDATE AP_Order_Head SET sync = true WHERE uuid = \'' + this.orderHead.uuid + '\'\n';
                        sql = sql + 'COMMIT RETRY 100\n';
                        this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                            this.orderHead.sync = true;
                        });
                        this.toasterService.pop('info', 'カレンダー追加', 'カレンダー追加されました。');
                    });
                }
            });
        }
    }

    export(grid: string, name: string) {
        if (this[grid] instanceof wjMultirow.MultiRow) {
            wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this[grid] as wjMultirow.MultiRow, {
                includeColumnHeaders: true,
                includeCellStyles: false
            }, name + '.xlsx');
        }
    }

    getSign() {
        this.hasSign = false;
        this.dataService.query({
            sql: 'SELECT uuid FROM AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'',
            count: 'SELECT uuid FROM AP_Image WHERE name =\'sign\' AND uuid = \'' + this.orderHead.uuid + '\'',
            fetchPlan: '*:1',
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results) && data.results.length > 0) {
                this.hasSign = true;
            }
        });
    }

    saveSign() {
        this.whiteboard.saveImage(this.orderHead.uuid, 'sign');
        this.signModal.hide();
        this.hasSign = true;
    }

    changeDepartment($event) {
        if (this.orderHead.department.indexOf('海外') == 0) {
            this.orderHead.status = '買取';
        }
    }

    isAbroad(): boolean {
        if (this.orderHead.department.indexOf('海外') == 0) {
            return true;
        }
        return false;
    }


}

